import messagesSlice from './slice';
import * as selectors from './selectors';
import * as actions from './actions';

export const MessagesReducer = messagesSlice.reducer;
export const MessagesActions = { ...actions, ...messagesSlice.actions };
export const MessagesSelectors = selectors;
